<template>
  <left-drawer-open-component v-if="auth">
    <router-view />
  </left-drawer-open-component>
  <router-view v-else />
</template>

<script>
import { computed, ref } from "vue";
import LeftDrawerOpenComponent from "./components/LeftDrawerOpenComponent.vue";
import { useStore } from "vuex";

export default {
  name: "LayoutDefault",
  components: {
    LeftDrawerOpenComponent,
  },
  setup() {
    const viewScheduling = ref(false);
    const store = useStore();
    const auth = computed(() => store.getters.getAuth);
    return {
      viewScheduling,
      auth,
    };
  },
};
</script>
